export const INITIAL = 'initial';
export const TRANSFER_LIMIT = 'limit';

export const SUCCESS = 'success';
export const SERVER_ERROR = 'serverError';
export const EXPIRED = 'expired';
